import { TasksSearchRequestDto } from '@/api/generated';
import {
  resourceTypeTranslation,
  ResourceTypeTranslation,
  taskStatusOptionsTranslation,
  TaskStatusOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl';

export type TasksListTableBodyTranslation = {
  actions: string;
  assignedUser: string;
  contextResourceType: string;
  creator: string;
  dueDate: string;
  resourceTypeOptions: ResourceTypeTranslation;
  status: string;
  taskStatusOptions: TaskStatusOptionsTranslation;
  title: string;
};

export const tasksListTablBodyTranslation: TasksListTableBodyTranslation = {
  actions: '',
  assignedUser: 'Przypisany pracownik',
  contextResourceType: 'Typ zasobu',
  creator: 'Twórca',
  dueDate: 'Termin',
  resourceTypeOptions: resourceTypeTranslation,
  status: 'Status',
  taskStatusOptions: taskStatusOptionsTranslation,
  title: 'Tytuł',
};

export type TasksListViewTranslation = {
  header: {
    button: {
      add: string;
    };
  };
  table: {
    body: TasksListTableBodyTranslation;
    head: Record<
      keyof Omit<TasksSearchRequestDto, 'contextResourceId' | 'includeOfferTasks'>,
      string
    > & {
      resourceTypeOptions: ResourceTypeTranslation;
      taskStatusOptions: TaskStatusOptionsTranslation;
    };
  };
};

export const tasksListViewTranslation: TasksListViewTranslation = {
  header: {
    button: {
      add: 'Dodaj',
    },
  },
  table: {
    body: tasksListTablBodyTranslation,
    head: {
      assignedUserId: 'Przypisane do',
      contextResourceTypes: 'Typy zasobu',
      creationDateFrom: 'Utworzone od',
      creationDateTo: 'Utworzone do',
      creatorUserId: 'Utworzone przez',
      dueDateFrom: 'Termin od',
      dueDateTo: 'Termin do',
      fullTextSearchInput: 'Tytuł lub opis',
      resourceTypeOptions: resourceTypeTranslation,
      taskStatuses: 'Status',
      taskStatusOptions: taskStatusOptionsTranslation,
      watchersUserIds: 'Obserwujący',
    },
  },
};
